module.exports = __webpack_public_path__ + "img/heather+doug+beach.8466c079.jpg";